import React, { useContext, useState } from 'react';
import { BookContent, BookIllustrations, LanguageContextData } from './types';
import { textValues, LanguageContext } from './utils';
import { FaArrowLeft, FaArrowRight, FaPrint } from 'react-icons/fa';

interface IllustrationSelectorProps {
  illustrationUrls: string[],
  setIllustrationIndex: (index: number) => void,
};

const IllustrationSelector = ({ illustrationUrls, setIllustrationIndex }: IllustrationSelectorProps) => {
  const [ index, setIndex ] = useState<number>(0);

  const setIndexIllustration = (change: number) => {
    const newIndex = index + change;
    setIndex(newIndex);
    setIllustrationIndex(newIndex);
  };

  return (
    <div className='selector'>
      { index > 0 && <span><div className='button' onClick={ () => setIndexIllustration(-1) }><FaArrowLeft /></div></span> }
      { index <= 0 && <span>&nbsp;</span> }
      <span><img src={ illustrationUrls[index] } alt='Illustration' /></span>
      { index < illustrationUrls.length - 1 && <span><div className='button' onClick={ () => setIndexIllustration(1) }><FaArrowRight /></div></span> }
      { index >= illustrationUrls.length - 1 && <span>&nbsp;</span> }
    </div>
  );
};

interface BookContentPageProps {
  bookContent: BookContent,
  bookIllustrations: BookIllustrations,
  setIllustrationIndices: (titleIndex: number, textIndices: number[]) => void,
};

const BookContentPage = ({ bookContent, bookIllustrations, setIllustrationIndices }: BookContentPageProps) => {
  const { language } = useContext<LanguageContextData>(LanguageContext);
  const [ titleIndex, setTitleIndex ] = useState<number>(0);
  const [ textIndices, setTextIndices ] = useState<number[]>(bookContent.text.map(_ => 0));

  const setIllustrationIndex = (illustrationIndex: number, paragraphIndex: number): void => {
    const newTextIndices = [ ...textIndices ];
    newTextIndices[paragraphIndex] = illustrationIndex;
    setTextIndices(newTextIndices);
  }

  return (
    <article>
      <h1>{ textValues[language]['illustrations'] }</h1>
      <section>
        <h2>{ bookContent.title }</h2>
        <IllustrationSelector illustrationUrls={ bookIllustrations.titleIllustrations } setIllustrationIndex={ setTitleIndex } />
      </section>
      { bookContent.text.map((paragraph, index) => (
        <section key={ index }>
          <p>{ paragraph }</p>
          <IllustrationSelector illustrationUrls={ bookIllustrations.textIllustrations[index] } setIllustrationIndex={ (illustrationIndex) => setIllustrationIndex(illustrationIndex, index) } />
        </section>
      )) }
      <section>
        <div className='row'>
          &nbsp;
          <button onClick={ (e) => { e.preventDefault(); setIllustrationIndices(titleIndex, textIndices) } }>{ textValues[language]['illustrationsButton'] } <FaPrint /></button> 
        </div>
      </section>
    </article>
  );
};
export default BookContentPage;